import { t } from '@lingui/macro';
import { i18n } from '@lingui/core';

export const COPY_MESSAGE = i18n._(t`Copied to clipboard`);
export default function copyToClipboard(textToCopy) {
    // Create a temporary text area from which the text can be selected.
    const el = document.createElement('textarea');
    el.value = textToCopy;
    el.setAttribute('readonly', '');
    el.style.position = 'absolute';
    el.style.left = '-9999px';
    document.body.appendChild(el);

    // Save any current selection so it can be restored.
    const selected = document.getSelection().rangeCount > 0 ? document.getSelection().getRangeAt(0) : false;

    // Copy the text to the clipboard, then remove the temporary text area.
    el.select();
    document.execCommand('copy');
    document.body.removeChild(el);

    // Restore any previous selection.
    if (selected) {
        document.getSelection().removeAllRanges();
        document.getSelection().addRange(selected);
    }
}
